






















































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Action, Getter, State } from 'vuex-class'
import { Route } from 'vue-router'

import {
  ConfirmLeaveModal,
  CreateOptionModal,
  NetworkErrorEmptyState,
  OptionGroupForm,
  VsDialog,
  VsLoading
} from '@/components'

import { ListItem, MobileLayout, SkeletonBox } from '@/layouts/components'

import {
  ActionButton,
  AsyncState,
  DropDownButton,
  ModalState,
  OptionGroup,
  OptionGroupContext,
  OptionGroupResourcePayload,
  OptionOuterContext
} from '@/models'

import { OptionGroupOptions } from '@/store/menu/state'
import { RelationMap } from '@/store/models'
import { RootState } from '@/store/state'

@Component({
  components: {
    ConfirmLeaveModal,
    CreateOptionModal,
    ListItem,
    MobileLayout,
    NetworkErrorEmptyState,
    OptionGroupForm,
    SkeletonBox,
    VsDialog,
    VsLoading
  }
})
export default class OptionGroupDetails extends Vue {
  @Prop({ type: Number, required: true })
  readonly itemGroupId!: number

  @Prop({ type: Number, required: true })
  readonly optionGroupId!: number

  loadState = new AsyncState()
  loadOptionsState = new AsyncState()
  updateOptionGroupState = new AsyncState()
  createOptionState =new ModalState()
  removeState = new ModalState()
  confirmLeaveState = new ModalState()
  confirmAddOptionState = new ModalState()

  data: OptionGroupResourcePayload | null = null
  isValid = false
  previousRoute: string | null = null

  confirmLeaveCallback: (() => void) | null = null

  showCanNotRemoveDialog = false

  get buttons (): (ActionButton | DropDownButton)[] {
    if (this.optionGroup === null) {
      return []
    }

    return [
      {
        text: 'Salvar',
        handler: this.handleSubmit,
        isDisabled: !this.hasChanges || !this.isValid || this.updateOptionGroupState.isPending
      },
      {
        icon: 'more_vert',
        color: 'dark',
        items: [
          {
            text: 'Remover',
            handler: () => {
              if (this.optionsTotal > 0) {
                this.showCanNotRemoveDialog = true
              } else {
                this.removeState.isActive = true
              }
            }
          }
        ]
      }
    ]
  }

  get context (): OptionGroupContext {
    return {
      id: this.optionGroupId,
      itemGroupId: this.itemGroupId
    }
  }

  get hasChanges () {
    const data = this.data
    const optionGroup = this.optionGroup

    return data !== null && optionGroup !== null && (
      data.title !== optionGroup.title ||
      data.maxlength !== optionGroup.maxLength ||
      data.required !== optionGroup.isRequired ||
      data.active !== optionGroup.isActive
    )
  }

  get isWaiting () {
    return (
      this.updateOptionGroupState.isPending ||
      this.removeState.isPending
    )
  }

  get optionGroup (): OptionGroup | null {
    return this.optionGroupByContext(this.context)
  }

  get optionGroupOptions (): OptionGroupOptions | undefined {
    return this.optionGroupsOptions[this.optionGroupId]
  }

  get optionsTotal () {
    return this.optionGroupOptions
      ? this.optionGroupOptions.total
      : 0
  }

  @State((state: RootState) => state.menu.optionGroups.options)
  readonly optionGroupsOptions!: RelationMap<OptionGroupOptions>

  @Getter('menu/optionGroupByContext')
  readonly optionGroupByContext!: (context: OptionGroupContext) => OptionGroup | null

  @Action('menu/loadOptionGroup')
  loadOptionGroup!: (context: OptionGroupContext) => Promise<void>

  @Action('menu/loadOptionPage')
  loadOptionPage!: (conext: OptionOuterContext) => Promise<void>

  @Action('menu/updateOptionGroup')
  updateOptionGroup!: (data: { id: number; payload: OptionGroupResourcePayload }) => Promise<void>

  @Action('menu/removeOptionGroup')
  removeOptionGroup!: (context: OptionGroupContext) => Promise<void>

  beforeRouteEnter (to: Route, from: Route, next: Function) {
    next((vm: this) => {
      vm.previousRoute = from.name ?? null
    })
  }

  async created () {
    if (this.optionGroup === null) {
      await this.reload()
    } else {
      this.loadState.touch()
    }

    if (this.optionGroup) {
      this.data = {
        groupId: this.itemGroupId,
        title: this.optionGroup.title,
        sequence: this.optionGroup.sequence,
        maxlength: this.optionGroup.maxLength,
        required: this.optionGroup.isRequired,
        active: this.optionGroup.isActive
      }
    }

    if (this.optionsTotal === 0) {
      this.handleLoadOptions()
    } else {
      this.loadOptionsState.touch()
    }
  }

  async reload () {
    try {
      await this.loadState.handle(
        this.loadOptionGroup(this.context)
      )
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  async handleLoadOptions () {
    try {
      await this.loadOptionsState.handle(
        this.loadOptionPage({
          optionGroupId: this.optionGroupId,
          itemGroupId: this.itemGroupId
        })
      )
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  async handleRemove () {
    try {
      await this.removeState.handle(
        this.removeOptionGroup(this.context)
      )

      this.$router.back()
    } catch (e) {
      this.$vs.notify({
        title: 'Não foi possível remover.',
        color: 'danger',
        fullWidth: true
      })

      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  async handleSubmit () {
    if (this.data === null || !this.hasChanges || !this.isValid) {
      return
    }

    try {
      await this.updateOptionGroupState.handle(
        this.updateOptionGroup({
          id: this.optionGroupId,
          payload: this.data
        })
      )
    } catch (e) {
      this.$vs.notify({
        title: 'Não foi possível alterar.',
        color: 'danger',
        fullWidth: true
      })

      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  confirmAddOption () {
    if (this.hasChanges) {
      this.confirmAddOptionState.isActive = true
    } else {
      this.createOptionState.isActive = true
    }
  }

  confirmLeave (callback: () => void) {
    if (this.hasChanges) {
      this.confirmLeaveCallback = callback
      this.confirmLeaveState.isActive = true
    } else {
      callback()
    }
  }

  goBack () {
    if (this.previousRoute === 'ItemGroupDetails') {
      this.$router.replace({ name: 'OptionGroups' })
    } else {
      this.$router.back()
    }
  }
}
